(ns app.front.view.project.bills
  (:require [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.view.fee.list :as fee-list]
            [app.front.view.fee.summary :as fee-summary]
            [app.front.view.project.subs :as ps]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::project-phase-ids
  (ps/child-entity-sub-signal-fn ::ps/project-workspace-ids)
  (fn [[entity-db workspace-ids] _]
    (->> entity-db
         vals
         (filter (comp workspace-ids :entity/parent))
         (filter fee-list/show-bills-for-phase-entity?)
         du/entity-id-set)))

(rf/reg-sub ::project-bill-ids
  (ps/child-entity-sub-signal-fn ::project-phase-ids)
  (ps/child-entity-sub-fn :entity.type/bill))

(rf/reg-sub ::bills
  (fn [[_ project-id]]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::project-bill-ids project-id])])
  (fn [[ctx bill-ids] _]
    (->> (entities/find-entities ctx bill-ids)
         fee-summary/group-bills)))

(rf/reg-sub ::has-bills?
  (fn [[_ project-id]]
    (rf/subscribe [::project-bill-ids project-id]))
  ps/sub-has-ids?)
